<template>
    <box :hideable="true">
        <h3 slot="header">
            <i class="fas fa-tasks"></i> {{resource('AnalysisSelection_Index_Queue_Header')}}
        </h3>
        <div slot="body">
            <div class="grid-container queue">
                <div>
                    <queue-buttons
                        :loading="loading"
                        :totalTime="totalTime()"
                        :selectedTime="selectedTime()"
                        @get-queue="getQueue"
                        @clear-queue="clearQueue"
                        @start-analysis="startAnalysis"
                    />
                </div>
                <div>
                    <data-table class="table table-striped"
                        :loading="loading"
                        :data="value"
                        :columns="columns"
                        :datatableOptions="datatableOptions"
                        :options="options"
                        @selected="addCall($event)"
                        @unselected="removeCall($event)"
                        @select-all="selectAll($event)"
                        @unselect-all="unselectAll($event)"
                    />
                </div>
                <div>
                    <queue-buttons
                        :loading="loading"
                        :totalTime="totalTime()"
                        :selectedTime="selectedTime()"
                        @get-queue="getQueue"
                        @clear-queue="clearQueue"
                        @start-analysis="startAnalysis"
                    />
                </div>
            </div>
        </div>

    </box>
</template>

<script>

//Api
import api from '../api';

//Util
import {status} from '../Util/analysis-status'
import growler from '../../../../../Core/Util/growler'
import { secondsToTimeString, dateToString, getStatus } from '../Util/calls';
import {sprintf} from 'sprintf-js';
import _ from 'lodash';

//Mixins
import callsTableMixin from '../Mixins/calls-table';
import resourceMixin from '../../../../../Core/Util/Mixins/resources';

//Components
import BootstrapBox from '../../../../../Core/Components/Util/BootstrapBox.vue';
import DataTable from '../../../../../Core/Components/Util/DataTable/DataTable.vue';
import QueueButtons from './QueueButtons.vue';

export default {
    name: 'analysis-queue',
    mixins: [resourceMixin, callsTableMixin],
    components: {
        'Box': BootstrapBox,
        DataTable,
        QueueButtons
    },
    created() {
        const vm = this;
        this.getQueue();

        api.validateControlPermission(api.permissionGrantType.write)
            .then( 
                () => vm.writePermission = true,
                () => vm.writePermission = false
            );

        api.validateControlPermission(api.permissionGrantType.delete)
            .then(
                () => vm.deletePermission = true,
                () => vm.deletePermission = false
            );
    },
    methods: {
        getQueue() {
            const vm = this;
            vm.loading = true;
            vm.selectedCalls = [];

            api.getCalls(status.draft).then(
                queue => {
                    vm.value = queue;
                    vm.value.forEach((call) => {
                        call.createdString = dateToString(call.created);
                        call.modifiedString = dateToString(call.modified);
                        call.durationString = secondsToTimeString(call.duration);
                        call.statusString = getStatus(call.status);
                        call.DT_RowId = call.callId
                    });

                    vm.loading = false;
                },
                error => {
                    growler.bootstrapDanger(error);
                    vm.loading = false;
                }
            );
        },
        clearQueue() {
            const vm = this;
            
            if(!vm.deletePermission) {
                growler.bootstrapWarning(vm.resource('AnalysisSelection_Index_Queue_NoDeletePermission_Message'));
                return;
            }
            
            vm.loading = true;

            api.clearQueue(vm.selectedCalls).then(
                result => {
                    vm.removeProcessed(result);
                    growler.bootstrapSuccess(
                        sprintf(
                            vm.resource('AnalysisSelection_Index_ClearQueue_Success'), 
                            result.length
                        )
                    );
                },
                error => {
                    growler.bootstrapDanger(error);
                    vm.loading = false;
                }
            );
        },
        startAnalysis() {
            const vm = this;

            if(!vm.writePermission) {
                growler.bootstrapWarning(vm.resource('AnalysisSelection_Index_Queue_NoWritePermission_Message'));
                return;
            }

            vm.loading = true;

            api.startAnalysis(vm.selectedCalls).then(
                result => {
                    vm.removeProcessed(result);
                    growler.bootstrapSuccess(
                        sprintf(
                            vm.resource('AnalysisSelection_Index_StartAnalysis_Success'), 
                            result.length
                        )
                    );
                },
                error => {
                    growler.bootstrapDanger(error);
                    vm.loading = false;
                }
            );
        },
        removeProcessed(removedCalls) {
            const vm = this;
            
            vm.value = vm.value.filter((call) => 
                removedCalls.indexOf(call.callId) === -1
            );

            vm.selectedCalls = [];
            vm.loading = false;
        },
        totalTime() {
            const times = this.value.map(call => call.duration);
            return _.sum(times);
        },
        selectedTime() {
            const vm = this;
            
            const times = vm.value
                .filter(call => 
                    vm.selectedCalls.indexOf(call.callId) !== -1
                ).map(call => 
                    call.duration
                );

            return _.sum(times);
        }
    },
    data() {
        const vm = this;

        return {
            loading: false,
            value: [], //Has to be called value. It is referenced in calls-table mixin.
            columns: [
                { data: 'callId', visible: false},
                { data: 'userId', visible: false},
                { title: vm.resource('CallsAnalysisModel_UserName_DisplayName'), data: 'userName'},
                { visible: false, data: 'created'},
                { title: vm.resource('CallsAnalysisModel_Created_DisplayName'), data: 'createdString'},
                { visible: false, data: 'modified'},
                { title: vm.resource('CallsAnalysisModel_Modified_DisplayName'), data: 'modifiedString'},
                { visible: false, data: 'duration'},
                { title: vm.resource('CallsAnalysisModel_Duration_DisplayName'), data: 'durationString'},
                { visible: false, data: 'status'},
                { title: vm.resource('CallsAnalysisModel_Status_DisplayName'), data: 'statusString', visible: false}],
            options: { select: { enabled: true } },
            datatableOptions: { lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]] },
            writePermission: false,
            deletePermission: false
        };
    }
};

</script>

<style lang="scss" scoped src="../Style/analysis-selection.scss">

</style>